export const queryKeys = {
  base: ['analytics'] as const,
  analyticsDashboard: (query: string) => [...queryKeys.base, 'analyticsDashboard', query],
  autoRecallAnalytics: (query?: string) => [...queryKeys.base, 'autoRecallAnalytics', query],
  callIntelligence: (query: string) => [...queryKeys.base, 'callIntelligence', query],
  listCallRecording: (tenantId: string) => ['phone', 'listCallRecording', tenantId],
  morningHuddle: (query?: string) => [...queryKeys.base, 'morningHuddle', query],
  morningHuddleReportEmails: (query?: string) => [...queryKeys.base, 'morningHuddleReportEmails', query],
  practiceAnalyticsCharts: (query?: string) => [...queryKeys.base, 'practiceAnalyticsCharts', query],
  practiceAnalyticsTables: (query?: string) => [...queryKeys.base, 'practiceAnalyticsTables', query],
  roiCharts: (query?: string) => [...queryKeys.base, 'roiCharts', query],
};
